export default __webpack_public_path__ + "static/media/6.332d6b6c.jpeg";